module.exports = __webpack_public_path__ + "img/message-icon.bb6a7415.svg";